import { mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { useEffect, useState } from "react";
import { useLang } from "../services/lang";

// TODO: use local session?
let userClosedPopUpSession = false;

export default function PopUp() {
    const { dict } = useLang();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (userClosedPopUpSession) return;

        // from google 
        const referrer = document.referrer.toLowerCase();
        const isFromGoogle = referrer.includes('google.com');

        // from ad
        const queryParams = new URLSearchParams(window.location.search);
        const isFromAd = queryParams.has('ad');

        if (isFromGoogle || isFromAd) {
            const timer = setTimeout(() => setIsVisible(true), 2000);

            return () => clearTimeout(timer);
        }
    }, []);

    function handleClose() {
        userClosedPopUpSession = true;
        setIsVisible(false);
    }

    if (!isVisible)
        return null;

    return <div className="popup">
        <div className="arrow">👇</div>
        <div className="block text">
            <div className="close" onClick={handleClose}><Icon path={mdiClose} size={1} /></div>
            {dict.popup}
        </div>
    </div>;
}